<template>
    <PageStyleComponent :key="mainComponentKey" :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader">
        <template v-slot:body>
            <div class="mt-6">
                <DynamicForm  :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" :displayButtons="displayButtons" @handleSubmit="saveUser" @handleReset="handleReset"> 
                    <template v-slot:additional-content>
                        <div class="border border-slate-200 rounded relative py-3 mt-3 px-2 flex">
                            <h1 class="font-bold absolute top-[-13px] left-5 bg-white">User Allowed Modules</h1>
                            <div class="px-3">
                                <DynamicForm :fields="additionalFields" :flex_basis="additional_flex_basis" :flex_basis_percentage="additional_flex_basis_percentage" @handleReset="handleReset"/>
                            </div>
                        </div>
                        <div class="border border-slate-200 rounded relative py-3 mt-3 px-2 flex">
                            <h1 class="font-bold absolute top-[-13px] left-5 bg-white">Module Configuration</h1>
                            <div class="px-3">
                                <DynamicForm :fields="additionalFields1" :flex_basis="additional_flex_basis" :flex_basis_percentage="additional_flex_basis_percentage" @handleReset="handleReset1"/>
                            </div>
                        </div>
                    </template>
                </DynamicForm>
            </div>
        </template>
    </PageStyleComponent>
</template>

<script>
import { defineComponent, ref, onBeforeMount, onMounted, computed, watch } from 'vue';
import DynamicForm from '@/components/NewDynamicForm.vue';
import PageStyleComponent from '@/components/PageStyleComponent.vue';
import { useStore } from "vuex";
import { useDateFormatter } from '@/composables/DateFormatter';
import { useToast } from "vue-toastification";
import axios from 'axios';

export default defineComponent({
    name: 'User_Details',
    components:{
        PageStyleComponent, DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('none');
        const mainComponentKey = ref(0);
        const componentKey = ref(0);
        const depComponentKey = ref(0);
        const outComponentKey = ref(0);
        const countComponentKey = ref(0);
        const errors = ref([]);
        const companyID = computed(()=> store.state.userData.company_id);
        const compModules = computed(() => store.state.userData.compModules);
        const displayButtons = ref(true);
        const isEditing = computed(()=> store.state.userData.isEditing);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const additional_flex_basis = ref('');
        const additional_flex_basis_percentage = ref('');
        const selectedUser = computed(()=> store.state.userData.selectedUser);
        const selectedDepartment = computed(()=> store.state.userData.selectedDepartment);
        const depArray = computed(() => store.state.Departments.depArr);
        const outletArray = computed(() => store.state.Retail_Outlets.outletArr);
        const counterArray = computed(() => store.state.Outlet_Counters.counterArr);
        const defaultCounter = computed(()=> store.state.userData.defaultCounter);
        const defaultOutlet = computed(()=> store.state.userData.defaultOutlet);
        const depID = ref('');
        const temporary_password = ref('');
        const userDetails = ref([]);

        const fetchDepartments = () =>{
            store.dispatch('Departments/fetchDepartments', {company: companyID.value})
        }

        const handleSelectedDepartment = async(option) =>{
            await store.dispatch('Departments/handleSelectedDepartment', option)
            depID.value = store.state.Departments.depID;
            if(selectedUser.value && selectedUser.value.user_department){
                selectedUser.value.user_department.department_id = depID.value;
                depValue.value = depID.value;
            }
        }
        const clearSelectedDepartment = async() =>{
            await store.dispatch('Departments/updateState', {depID: ''});
            depID.value = store.state.Departments.depID;
            console.log("THE DEP VALUE IS ",depValue.value)
        };

        const formFields = ref([]);
        const depValue = computed(() => {
           return (selectedUser.value && selectedUser.value.user_department && depID.value != '') ? selectedUser.value.user_department.department_id : depID.value;

        });
        const updateFormFields = () => {
            formFields.value = [
                { type: 'text', name: 'first_name',label: "First Name", value: selectedUser.value?.first_name || '', required: true },
                { type: 'text', name: 'last_name',label: "Last Name", value: selectedUser.value?.last_name || '', required: true },
                { type: 'text', name: 'identification_no',label: "ID Number", value: selectedUser.value?.identification_no || '', required: true },
                { type: 'text', name: 'email',label: "Email", value: selectedUser.value?.email || '', required: true, placeholder: '' },
                { type: 'text', name: 'phone_number',label: "Phone Number", value: selectedUser.value?.phone_number || '', required: true },
                { type: 'date', name: 'birth_date',label: "D.O.B", value: selectedUser.value?.birth_date || '', required: false },
                { type: 'dropdown', name: 'gender',label: "Gender", value: selectedUser.value?.gender || '', placeholder: "", required: true, options: [{ text: 'Male', value: 'Male' }, { text: 'Female', value: 'Female' }, { text: 'Other', value: 'Other' }] },
                { type: 'dropdown', name: 'profile',label: "Profile", value: selectedUser.value?.profile || '', placeholder: "", required: true, options: [{text:'Admin',value:'Admin'},{text:'Property Manager',value:'Property Manager'},{text:'Accountant',value:'Accountant'},{text:'Human Resource',value:'Human Resource'},{text:'Credit Officer',value:'Credit Officer'},{text:'Office Clerk',value:'Office Clerk'},
                    {text:'Employee',value:'Employee'},{text:'Member',value:'Member'},{text:'Sales Agent',value:'Sales Agent'}
                ] },

                {  
                    type:'search-dropdown', label:"Department", value: depValue.value, componentKey: depComponentKey,
                    selectOptions: depArray, optionSelected: handleSelectedDepartment, required: false,
                    searchPlaceholder: 'Select Department...', dropdownWidth: '400px', updateValue: selectedDepartment.value,
                    clearSearch: clearSelectedDepartment
                },
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            depID.value = '';
            for(let i=0; i < additionalFields.value.length; i++){
                additionalFields.value[i].value = '';
            }
            depComponentKey.value += 1;
        }


        const displayInventoryOptions = (value) =>{
            if(value == 'Enabled'){
                additionalFields1.value[0].hidden = false;
                additionalFields1.value[1].hidden = false;
                additionalFields1.value[2].hidden = false;
                fetchOutlets();
            }else{
                additionalFields1.value[0].hidden = true;
                additionalFields1.value[1].hidden = true;
                additionalFields1.value[2].hidden = true;
            }
        };
        const filterCompanyModules = (moduleName) =>{
            for(let mod of compModules.value){
                if(mod.module_name == moduleName){
                    return true;
                }
            }
        }

        const additionalFields = ref([]);
        const updateAdditionalFormFields = () => {
            additionalFields.value = [
                { type: 'dropdown', name: 'pms_module',label: "Property Management", value: selectedUser.value?.pms_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },
                { type: 'dropdown', name: 'accounts_module',label: "Financial Accounts", value: selectedUser.value?.accounts_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },
                { type: 'dropdown', name: 'inventory_module',label: "Inventory Management", value: selectedUser.value?.inventory_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }], method: displayInventoryOptions },
                { type: 'dropdown', name: 'hms_module',label: "Hospital Management", value: selectedUser.value?.hms_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },
                { type: 'dropdown', name: 'hr_module',label: "Human Resource", value: selectedUser.value?.hr_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },
                { type: 'dropdown', name: 'settings_module',label: "Settings", value: selectedUser.value?.settings_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },
                { type: 'dropdown', name: 'hhs_module',label: "Hotel Management", value: selectedUser.value?.hhs_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },
                { type: 'dropdown', name: 'mms_module',label: "Membership Management", value: selectedUser.value?.mms_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },
                { type: 'dropdown', name: 'pss_module',label: "Property Sales", value: selectedUser.value?.pss_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] }, 
                { type: 'dropdown', name: 'vss_module',label: "Vehicle Sales", value: selectedUser.value?.vss_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] },  
                { type: 'dropdown', name: 'crm_module',label: "CRM", value: selectedUser.value?.crm_module || 'Disabled', placeholder: "", required: true, disabled: false, options: [{ text: 'Enabled', value: 'Enabled' }, { text: 'Disabled', value: 'Disabled' }] }, 
                {required: false},
                {required: false},
            ];
        };
        const outletID = ref(null);
        const counterID = ref(null);

        const fetchOutlets = async() =>{
            await store.dispatch('Retail_Outlets/fetchOutlets', {company:companyID.value})
        };
        const fetchCounters = async() =>{
            if(outletID.value){
                await store.dispatch('Outlet_Counters/fetchCounters', {company:companyID.value, outlet:outletID.value})
            }
        };
        const handleSelectedCounter = async(option) =>{
            await store.dispatch('Outlet_Counters/handleSelectedCounter', option)
            counterID.value = store.state.Outlet_Counters.counterID;
        };
        const handleSelectedOutlet = async(option) =>{
            await store.dispatch('Retail_Outlets/handleSelectedOutlet', option)
            outletID.value = store.state.Retail_Outlets.outletID;
        };
        const clearSelectedCounter = async() =>{
            await store.dispatch('Outlet_Counters/updateState', {counterID: ''});
            counterID.value = null;
        }
        const clearSelectedOutlet = async() =>{
            await store.dispatch('Retail_Outlets/updateState', {outletID: ''});
            outletID.value = null;
        };
        watch([outletID], () => {
            if (outletID.value) {
                fetchCounters();
            }
            
        }, { immediate: true });
        const additionalFields1 = ref([]);
        const updateAdditionalFormFields1 = () => {
            additionalFields1.value = [
                {
                    type:'search-dropdown', label:"Outlet", value: outletID.value, componentKey: outComponentKey,
                    selectOptions: outletArray, optionSelected: handleSelectedOutlet, required: false, hidden:true, 
                    searchPlaceholder: 'Select Outlet...', dropdownWidth: '280px', updateValue: defaultOutlet.value,
                    clearSearch: clearSelectedOutlet()  
                },
                {
                    type:'search-dropdown', label:"Counter", value: counterID.value, componentKey: countComponentKey,
                    selectOptions: counterArray, optionSelected: handleSelectedCounter, required: false, hidden:true,
                    searchPlaceholder: 'Select Counter...', dropdownWidth: '280px', updateValue: defaultCounter.value,
                    clearSearch: clearSelectedCounter()  
                },
                { type: 'dropdown', name: 'user_inv_sales_limit',label: "Limit Inv. Sales User", value: selectedUser.value?.user_inv_sales_limit || 'No', placeholder: "", required: false, hidden:true, options: [{ text: 'Yes', value: 'Yes' }, { text: 'No', value: 'No' }] },
                {required: false},
            ];
        };
        const applyingModulesFilter = () =>{
            for(let i=0; i < additionalFields.value.length; i++){
                let result = filterCompanyModules(additionalFields.value[i].label);
                if(!result){
                    additionalFields.value[i].disabled = true;
                }else{
                    additionalFields.value[i].disabled = false;
                }
            }
        }
        watch([selectedUser, selectedDepartment], () => {
            if(selectedUser.value  && selectedDepartment.value){
                depComponentKey.value += 1;
                updateFormFields();
                updateAdditionalFormFields();
                updateAdditionalFormFields1();
                displayInventoryOptions(selectedUser.value?.inventory_module || 'Disabled');
                applyingModulesFilter();
            }else if(selectedUser.value){
                updateFormFields();
                updateAdditionalFormFields();
                updateAdditionalFormFields1();
                displayInventoryOptions(selectedUser.value?.inventory_module || 'Disabled');
                applyingModulesFilter();
            }else{
                applyingModulesFilter();
            }
            
        }, { immediate: true });
         
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        } 
        const createUser = async() =>{
            showLoader();

            errors.value = [];
            for(let i=0; i < (formFields.value.length - 1); i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            for(let i=0; i < additionalFields.value.length; i++){
                if(additionalFields.value[i].value =='' && additionalFields.value[i].required == true){
                    errors.value.push(additionalFields.value[i].label);
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideLoader();                 
            }else{            
                try {
                    const response1 = await axios.get("api/v1/pass-gen/");
                    temporary_password.value = response1.data;
                    
                    let obj1 = {
                        "user_inv_sales_limit": additionalFields1.value[2].value
                    }
                    let formData = {
                        company: companyID.value,
                        first_name: formFields.value[0].value,
                        last_name: formFields.value[1].value,
                        is_staff: true,
                        is_active: true,
                        password_reset: false,
                        email: formFields.value[3].value,
                        identification_no: formFields.value[2].value,
                        birth_date: formFields.value[5].value,
                        gender: formFields.value[6].value,
                        phone_number: formFields.value[4].value,
                        profile: formFields.value[7].value,
                        pms_module: additionalFields.value[0].value,
                        hms_module: additionalFields.value[3].value,
                        accounts_module: additionalFields.value[1].value,
                        hr_module: additionalFields.value[4].value,
                        inventory_module: additionalFields.value[2].value,
                        settings_module: additionalFields.value[5].value,
                        hhs_module: additionalFields.value[6].value,
                        mms_module: additionalFields.value[7].value,
                        pss_module: additionalFields.value[8].value,
                        vss_module: additionalFields.value[9].value,
                        crm_module: additionalFields.value[10].value,
                        user_department: depValue.value,
                        password: temporary_password.value,
                        default_counter: counterID.value,
                        default_outlet: outletID.value,
                        user_configs: JSON.stringify(obj1)
                    }

                    const response2 = await axios.post("api/v1/users/", formData);
                    if (response2.status == 201){
                        userDetails.value = response2.data;

                        let formData1 ={
                            temporary_password: temporary_password.value,
                            company: companyID.value
                        }

                        await axios.post(`api/v1/user-credentials/${userDetails.value.user_id}/`, formData1)
                        .then(()=>{
                            hideLoader();
                            toast.success('User created successfully!');
                            handleReset();
                            mainComponentKey.value += 1;
                            depComponentKey.value += 1;
                        })
                        
                    }else {
                        toast.error('An error occurred while creating the User.');
                        hideLoader();
                    }
                    
                } catch (error) {
                    toast.error('Failed to create User: ' + error.message);
                } finally {
                    hideLoader();
                }              
            }
        }

        const updateUser = async() => {
            showLoader();
            errors.value = [];
            for(let i=0; i < (formFields.value.length -1); i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            for(let i=0; i < additionalFields.value.length; i++){
                if(additionalFields.value[i].value =='' && additionalFields.value[i].required == true){
                    errors.value.push(additionalFields.value[i].label);
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
                    hideLoader();
            }else{
                let obj1 = {
                    "user_inv_sales_limit": additionalFields1.value[2].value
                }
                const updatedUser = {
                    user: selectedUser.value.user_id,
                    company: companyID.value,
                    first_name: formFields.value[0].value,
                    last_name: formFields.value[1].value,
                    is_staff: selectedUser.value.is_staff,
                    is_active: selectedUser.value.is_active,
                    password_reset: selectedUser.value.password_reset,
                    email: formFields.value[3].value,
                    identification_no: formFields.value[2].value,
                    birth_date: formFields.value[5].value,
                    gender: formFields.value[6].value,
                    phone_number: formFields.value[4].value,
                    profile: formFields.value[7].value,
                    pms_module: additionalFields.value[0].value,
                    hms_module: additionalFields.value[3].value,
                    accounts_module: additionalFields.value[1].value,
                    hr_module: additionalFields.value[4].value,
                    inventory_module: additionalFields.value[2].value,
                    settings_module: additionalFields.value[5].value,
                    hhs_module: additionalFields.value[6].value,
                    mms_module: additionalFields.value[7].value,
                    pss_module: additionalFields.value[8].value,
                    vss_module: additionalFields.value[9].value,
                    crm_module: additionalFields.value[10].value,
                    user_department: depValue.value,
                    default_counter: counterID.value,
                    default_outlet: outletID.value,
                    user_configs: JSON.stringify(obj1)
                };

                try {
                        const response = await store.dispatch('userData/updateUser', updatedUser);
                        if (response) {
                            hideLoader();
                            toast.success('User updated successfully!');
                            handleReset();
                            depComponentKey.value += 1;
                            mainComponentKey.value += 1;
                            await store.dispatch('Departments/updateState',{depID:''})
                            await store.dispatch("userData/updateState",{selectedUser:null, selectedDepartment:null})
                        } else {
                            toast.error('An error occurred while updating the User.');
                            hideLoader();
                        }
                    } catch (error) {
                        console.error(error.message);
                        toast.error('Failed to update User: ' + error.message);
                    } finally {
                        hideLoader();
                    }
            }                    
        };

        const saveUser = () =>{
            if(isEditing.value == true){
                updateUser();
            }else{
                createUser();
            }
        }
        
        onBeforeMount(()=>{ 
            updateFormFields();
            updateAdditionalFormFields();
            updateAdditionalFormFields1();
            applyingModulesFilter();
            depComponentKey.value += 1;
            flex_basis.value = '1/4';
            flex_basis_percentage.value = '25';
            additional_flex_basis.value = '1/4';
            additional_flex_basis_percentage.value = '20';
            fetchDepartments();
        })
        onMounted(()=>{

        })

        return{
            componentKey, formFields, additionalFields, flex_basis, flex_basis_percentage, additional_flex_basis,
            additional_flex_basis_percentage, displayButtons, saveUser, mainComponentKey,
            handleReset, isEditing, loader, showLoader, hideLoader, additionalFields1
        }
    }
})
</script>